import { isExist, getTimestamp } from 'common/utils';
import { TaxActions, Action } from 'common/types';
import { getTaxEntity } from 'common/assets';
import { auth,db } from 'firebase/config';
import { setDocWithCreatedBy } from 'firebase/utils';
import { collection, doc, addDoc,setDoc, updateDoc, deleteDoc, CollectionReference, DocumentData } from 'firebase/firestore';

const taxesCollection: CollectionReference<DocumentData> = collection(db, 'taxes');

export const createTaxActions: Action<TaxActions> = (state, updateState) => ({
  // add a tax
  add: async (tax) => {
    const newTax = getTaxEntity(tax);
    
    await setDocWithCreatedBy(taxesCollection, newTax);
    updateState({ taxes: [...state.taxes, newTax] });
    return newTax;
  },

  // remove a tax
  remove: async (taxId) => {
    try {
      // Delete from Firestore
      const taxRef = doc(taxesCollection, taxId);
      await deleteDoc(taxRef);

      // Update local state
      const updTaxes = [...state.taxes];
      const targetEntity = state.taxes.findIndex((entity) => taxId === entity.id);
      if (!isExist(targetEntity)) throw new Error('The specified tax does not exist');
      updTaxes[targetEntity].isDeleted = true;
      updateState({ taxes: updTaxes });
    } catch (error) {
      console.error('Error removing tax:', error);
      throw error;
    }
  },

  // update a tax
  update: async (tax) => {
    try {
      // Update in Firestore
      const taxRef = doc(taxesCollection, tax.id);
      const updatedTax = { ...tax, lastModifiedTime: getTimestamp() };
      await updateDoc(taxRef, updatedTax);

      // Update local state
      const updTaxes = [...state.taxes.filter((entity) => entity.id !== tax.id), updatedTax];
      updateState({ taxes: updTaxes });
      return updatedTax;
    } catch (error) {
      console.error('Error updating tax:', error);
      throw error;
    }
  },
});
